import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.DegreeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    degreeEnumList: { items: data, total },
  } = await sdk.getListDegreeEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { degreeEnum: data } = await sdk.getOneDegreeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { degreeEnumMany: data } = await sdk.getManyDegreeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const degreeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
